export default __webpack_public_path__ + "static/bolge-accent-d958545d25fe44118cd4942977d30555.png";